import request from '@api/request';
export const CHANNEL_ID = '61fb40aa6c1a754381c3f219';

export const postListApi = async (params) =>
  await request({
    url: `/posts/channel/${CHANNEL_ID}`,
    type: 'get',
    params,
  });

export const CreatePostApi = async (params) =>
  await request({
    url: '/posts/create',
    type: 'post',
    params,
  });

export const UserPostListApi = async ({ userId, limit, offset }) =>
  await request({
    url: `/posts/author/${userId}?offset=${offset}&limit=${limit}`,
    type: 'get',
  });

export const ModifyProfile = async (params) => {
  await request({
    url: '/users/upload-photo',
    type: 'post',
    params,
  });
};

export const DeletePostApi = async (params) => {
  await request({
    url: '/posts/delete',
    type: 'delete',
    params,
  });
};
